import ApiInfo from './ApiInfo.js';

class SalesPermApiInfo extends ApiInfo {
  constructor({
    path,
    type = 'get',
    timeout = 30000,
    headers,
    project = 'perm',
    author = '未定义',
  }) {
    super({
      path,
      type,
      timeout,
      headers,
      project,
      author,
    });
  }
}

export default {
  member: {
    checkPerm: new SalesPermApiInfo({
      path: '/member/checkPerm',
      type: 'post',
      author: '刘彪',
    }),
  },
  perm: {
    list: new SalesPermApiInfo({
      path: '/perm/getPermGroupList',
      type: 'post',
      author: '刘彪',
    }),
  },
};
